export { default, ChatWidgetButton } from './ChatWidgetButton';



// WEBPACK FOOTER //
// ./app/components/search/ChatWidgetButton/index.js